import React from 'react'
import "./banner.css"
import Bannerimg from "../../asset/images/mainimg.png"

const Banner = () => {
  return (
    <div className="banner-bg">
      <div className="overlay-content">
      </div>
    </div>
  )
}

export default Banner